(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/init.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs.ticket_gifts.init = async () => {
  const PlayerRouter = svs.app.ReactRouter.PlayerRouter;
  const Route = svs.app.ReactRouter.Route;
  const baseUrl = svs.core.data.baseUrl;
  const Redeem = svs.ticket_gifts.redeem.components.Redeem;
  const Barcode = svs.ticket_gifts.barcode.components.Barcode;
  const {
    UnavailableTicket
  } = svs.ticket_gifts.redeem.components.unavailableTicket;
  const TicketGifts = svs.ticket_gifts.components.TicketGifts;
  const GameLauncherWrapper = svs.ticket_gifts.redeem.components.GameLauncherWrapper;
  const AsyncRoute = svs.ticket_gifts.redeem.components.AsyncRoute;
  const giftCode = location.pathname.split('/')[2];
  const chooseGameForVoucher = svs.ticket_gifts.chooseGameForVoucher;
  let voucherData;
  try {
    svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && (voucherData = await getVouchers(giftCode));
  } catch (e) {
    if (e.code === '26 102' || e.code === '26 3') {
      window.location.href = "".concat(svs.core.data.baseUrl, "?err=").concat(giftCode);
      return;
    }
    return svs.tur.apierrors.showErrorMessage({
      response: e.code,
      onConfirm: () => {
        window.location.href = svs.core.data.baseUrl;
      }
    });
  }
  const getActiveVouchers = (voucherData, voucherIndex, voucherCode) => [...voucherData.vouchers.slice(voucherIndex), ...voucherData.vouchers.slice(0, voucherIndex)].filter(v => v.state === 'ACTIVE' && v.voucherId !== voucherCode).sort((a, b) => Boolean(chooseGameForVoucher(b)) - Boolean(chooseGameForVoucher(a))); 

  ReactDOM.render( React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Route, {
    component: _ref => {
      let {
        history
      } = _ref;
      const errParams = svs.utils.paramHandler.get({
        key: 'err'
      });
      return React.createElement(TicketGifts, {
        faultyBarcode: errParams.value,
        history: history
      });
    },
    exact: true,
    path: "/"
  }), React.createElement(Route, {
    component: _ref2 => {
      let {
        history,
        match
      } = _ref2;
      const ticketsSearchParams = svs.utils.paramHandler.get({
        key: 'tickets'
      });
      const priceSearchParams = svs.utils.paramHandler.get({
        key: 'price'
      });
      const numberOfTickets = ticketsSearchParams.key && Number(ticketsSearchParams.value) || 0;
      const totalPrice = priceSearchParams.key && Number(priceSearchParams.value) || 0;
      return React.createElement(Redeem, {
        history: history,
        isPlayer: svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER),
        match: match,
        numberOfTickets: numberOfTickets,
        totalPrice: totalPrice,
        voucherData: voucherData
      });
    },
    exact: true,
    path: "/:giftCode"
  }), React.createElement(Route, {
    component: _ref3 => {
      let {
        match,
        history
      } = _ref3;
      return React.createElement(AsyncRoute, {
        key: match.params.voucherCode,
        todo: done => {
          const {
            voucherCode
          } = match.params;
          if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
            return svs.components.customer_login.login();
          }
          const voucherIndex = _.findIndex(voucherData.vouchers, v => v.voucherId === voucherCode);
          const voucher = voucherData.vouchers[voucherIndex];
          const ticketInfo = chooseGameForVoucher(voucher);
          const skinId = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.normalizeSkinId(voucher.ticketPosition);
          const activeVouchers = getActiveVouchers(voucherData, voucherIndex, voucherCode);
          const nextVoucher = activeVouchers[0];
          const wagerId = svs.utils.paramHandler.get({
            key: 'wagerId'
          }).value;
          const onClose = e => {
            var _voucherData;
            e === null || e === void 0 || e.preventDefault();
            if (((_voucherData = voucherData) === null || _voucherData === void 0 || (_voucherData = _voucherData.vouchers) === null || _voucherData === void 0 ? void 0 : _voucherData.length) === 1) {
              window.location.href = "".concat(svs.core.urlMapping.get('myBetsHome'));
            } else {
              window.location.href = "".concat(svs.core.urlMapping.get('ticketGiftHome'), "/").concat(voucherCode);
            }
          };
          if (!ticketInfo) {
            done(() => React.createElement(UnavailableTicket, {
              history: history,
              voucher: voucher
            }));
          } else if (!wagerId || wagerId.toLowerCase() === 'PENDING') {
            voucher.state = 'CLAIMED';
            svs.utils.paramHandler.set({
              key: 'wagerId',
              value: 'PENDING'
            });
            done(() => React.createElement(GameLauncherWrapper, {
              history: history,
              match: match,
              nextVoucher: nextVoucher,
              onClose: onClose,
              skinId: skinId,
              ticketInfo: ticketInfo,
              voucherCode: voucherCode
            }));
          } else {
            voucher.state = 'CLAIMED';
            done(() => React.createElement(GameLauncherWrapper, {
              history: history,
              isPurchaseDisabled: true,
              match: match,
              nextVoucher: nextVoucher,
              onClose: onClose,
              ticketInfo: ticketInfo,
              wagerId: wagerId
            }));
          }
        }
      });
    },
    exact: true,
    path: "/:giftCode/spela/:voucherCode"
  }), React.createElement(Route, {
    component: _ref4 => {
      var _voucherData2;
      let {
        match: {
          params: {
            giftCode
          }
        },
        history
      } = _ref4;
      let nextVoucher = null;
      let availableOnline = false;
      const ticketsSearchParams = svs.utils.paramHandler.get({
        key: 'tickets'
      });
      const priceSearchParams = svs.utils.paramHandler.get({
        key: 'price'
      });
      const manual = svs.utils.paramHandler.get({
        key: 'manual'
      });
      svs.utils.paramHandler.remove({
        key: 'manual'
      });
      const numberOfTickets = ticketsSearchParams.key && Number(ticketsSearchParams.value) || 0;
      const totalPrice = priceSearchParams.key && Number(priceSearchParams.value) || 0;
      if ((_voucherData2 = voucherData) !== null && _voucherData2 !== void 0 && _voucherData2.vouchers) {
        var _voucherData3, _voucherData4, _voucherData5;
        const voucherIndex = _.findIndex((_voucherData3 = voucherData) === null || _voucherData3 === void 0 ? void 0 : _voucherData3.vouchers, v => v.voucherId === giftCode);
        const activeVouchers = getActiveVouchers(voucherData, voucherIndex, giftCode);
        nextVoucher = activeVouchers && activeVouchers[0];
        availableOnline = ((_voucherData4 = voucherData) === null || _voucherData4 === void 0 ? void 0 : _voucherData4.vouchers) && chooseGameForVoucher((_voucherData5 = voucherData) === null || _voucherData5 === void 0 ? void 0 : _voucherData5.vouchers[voucherIndex]);
      }
      return React.createElement(Barcode, {
        availableOnline: availableOnline,
        giftCode: giftCode,
        history: history,
        manual: Boolean(JSON.parse(manual && manual.value)),
        nextVoucher: nextVoucher,
        numberOfTickets: numberOfTickets,
        totalPrice: totalPrice
      });
    },
    exact: true,
    path: "/:giftCode/streckkod"
  })), document.getElementById('reactContainer'));
};
svs.ticket_gifts.init();
svs.ticket_gifts.getVouchers = getVouchers;
async function getVouchers(giftcode) {
  let api = 5;
  if (svs.core.detect.feature('ft-its-api-version')) {
    api = 6;
  }
  if (giftcode) {
    return new Promise((resolve, reject) => {
      svs.components.loader.show();
      const paths = ["/voucher/1/vouchermetadata?voucherId=".concat(giftcode.toUpperCase()), "/voucher/".concat(api, "/getvoucher?voucherId=").concat(giftcode.toUpperCase())];
      const success = data => {
        svs.components.loader.hide();
        const voucherMetadata = data.responses[0];
        const vouchersData = data.responses[1];
        const personalMessage = voucherMetadata && voucherMetadata.personalMessage && voucherMetadata.personalMessage.replace(/\\n/g, '\n');
        if (!vouchersData.voucherInfo) {
          if (voucherMetadata.vouchers && voucherMetadata.vouchers.length === 1 && voucherMetadata.vouchers[0].voucherId === giftcode.slice(0, 8) && giftcode.length === 12) {
            return resolve(_objectSpread(_objectSpread({}, voucherMetadata), {}, {
              vouchers: [_objectSpread(_objectSpread({}, voucherMetadata.vouchers[0]), {}, {
                voucherId: giftcode
              })]
            }));
          }
          return reject(vouchersData.error);
        }
        if (!voucherMetadata.vouchers) {
          return resolve(_objectSpread(_objectSpread(_objectSpread({}, voucherMetadata), vouchersData), {}, {
            personalMessage,
            vouchers: vouchersData.voucherInfo.map(voucher => _objectSpread(_objectSpread({}, voucher), {}, {
              voucherConfigId: voucher.packageId,
              value: voucher.voucherValue
            }))
          }));
        }
        return resolve(_objectSpread(_objectSpread({}, voucherMetadata), {}, {
          personalMessage,
          vouchers: voucherMetadata.vouchers.map(metadata => _objectSpread(_objectSpread({}, metadata), {}, {
            voucherId: vouchersData.voucherInfo.find(voucher => voucher.voucherId.slice(0, 8) === metadata.voucherId).voucherId
          }))
        }));
      };
      svs.core.jupiter.get("/multifetch?urls=".concat(paths.join('|')), success);
    });
  }
  return {};
}

 })(window);